import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=64d7d104&scoped=true"
var script = {}
import style0 from "./Imprint.vue?vue&type=style&index=0&id=64d7d104&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7d104",
  null
  
)

export default component.exports